const pageTypes = [
  'customer',
  'customers',
  'invoices',
  'load-error',
  'authentication-error',
  'forbidden',
  'unknown',
] as const;

export type PageType = (typeof pageTypes)[number];

const isPageType = (segment: string): segment is PageType => pageTypes.includes(segment as PageType);

export const getPageType = (path: string): PageType => {
  const segments = path?.split('/').filter((x) => !!x);
  return segments.filter(isPageType).pop() || 'unknown';
};

const buildUrl = (segments: string[]) => {
  return segments.join('/').replace(/\/+/g, '/');
};

export const getSinglePagePath = (path: string): string => {
  const pathWithoutIds = path.replace(/\/\d{12}/g, '');
  const pageType = getPageType(pathWithoutIds);
  const pageNames = pathWithoutIds?.split('/').filter((x) => !!x);
  const firstRelevantIndex = pageNames.indexOf(pageType);

  if (firstRelevantIndex === -1) return pathWithoutIds;

  return buildUrl(['/', ...pageNames.slice(firstRelevantIndex)]);
};
